import { CSSProperties, FC, Fragment } from "react";

export const Restaurant: FC<CSSProperties> = ({
  textDecoration = "underline",
  color = "white",
}) => {
  return (
    <Fragment>
      Restaurant&nbsp;&nbsp;&nbsp;
      <a
        href="https://maps.app.goo.gl/azozzTEqHMiedzbJ9"
        target="_blank"
        rel="noreferrer"
        style={{ color, textDecoration }}
      >
        1743 Cucina Italiana
      </a>
    </Fragment>
  );
};
